<template>
  <ValidationObserver
    ref="editProfile"
    v-slot="{ invalid, changed }"
    name="editProfile"
    tag="form"
  >
    <VForm
      ref="form"
      data-test="form"
      class="p-4"
    >
      <div class="mb-4">
        <span
          class="heading-6 textPrimary--text font-weight-bold"
        >
          {{ $t('settings.editProfile') }}
        </span>
      </div>
      <vue-tel-input-vuetify
        ref="phoneInput"
        :value="newProfile.phone"
        data-test="phoneInput"
        disabled
        defaultCountry="LU"
        disabledFetchingCountry
        :placeholder="$t('authForm.enterPhoneNumber')"
        :label="$t('settings.phone')"
      />
      <ValidationProvider
        ref="firstName"
        v-slot="{ errors, ariaInput }"
        name="firstName"
        :rules="{ required: true, max: 255, atLeastTwoLetters: /[a-zA-Z]{2,}/, onlyLettersAndSymbols: firstSecondNameRegex }"
        mode="aggressive"
      >
        <VTextField
          v-bind="ariaInput"
          v-model="newProfile.firstName"
          :label="$t('settings.firstName')"
          data-test="firstNameInput"
          :hide-details="!errors.length"
          :error="!!errors.length"
          :error-messages="validationErrorResolve(errors[0])"
        />
      </ValidationProvider>
      <ValidationProvider
        ref="lastName"
        v-slot="{ errors, ariaInput }"
        name="lastName"
        :rules="{ required: true, max: 255, atLeastTwoLetters: /[a-zA-Z]{2,}/, onlyLettersAndSymbols: firstSecondNameRegex }"
        mode="aggressive"
      >
        <VTextField
          v-bind="ariaInput"
          v-model="newProfile.lastName"
          :label="$t('settings.lastName')"
          data-test="lastNameInput"
          :hide-details="!errors.length"
          :error="!!errors.length"
          :error-messages="validationErrorResolve(errors[0])"
        />
      </ValidationProvider>
      <ValidationProvider
        ref="email"
        v-slot="{ errors, ariaInput }"
        name="email"
        :rules="{ email: true }"
        mode="aggressive"
      >
        <VTextField
          v-model="newProfile.email"
          :label="$t('settings.email')"
          data-test="emailInput"
          :hide-details="!errors.length"
          :error="!!errors.length"
          :error-messages="$t(errors[0])"
        />
      </ValidationProvider>
      <div class="d-flex justify-end">
        <VBtn
          text
          class="body-2 ml-4"
          data-test="cancelUpdateProfileButton"
          @click="cancel"
        >
          {{ $t('settings.cancel') }}
        </VBtn>

        <VBtn
          text
          color="brandingPrimary"
          data-test="saveProfileButton"
          class="body-2 ml-4"
          :disabled="invalid || !changed"
          @click="$emit('updateProfile', newProfile)"
        >
          {{ $t('general.save') }}
        </VBtn>
      </div>
    </VForm>
  </ValidationObserver>
</template>

<script lang="ts">
export default {
  name: 'EditProfile',
};
</script>

<script setup lang="ts">
import { reactive, ref } from 'vue';
import Constants from '@slg/web-customer-shared/src/utils/constants';
import { useValidationError } from '../../../composables';

const props = defineProps({
  profile: {
    type: Object,
    default: () => {},
  },
});

const emit = defineEmits(['closeForm']);

const { validationErrorResolve } = useValidationError();

const newProfile = reactive({
  phone: '',
  firstName: '',
  lastName: '',
  email: '',
});
const firstSecondNameRegex = Constants.FIRST_SECOND_NAME_REGEX;
const isInfoChanged = ref(false);

newProfile.phone = (props.profile as any).phone;
newProfile.firstName = (props.profile as any).firstName;
newProfile.lastName = (props.profile as any).lastName;
newProfile.email = (props.profile as any).email;

function cancel() {
  emit('closeForm', newProfile);
}
</script>
